export default "__VITE_ASSET__B8n43jn5__"